// Kleur pas doorstrepen als ALLE maten van die kleur uitverkocht zijn (04-10).
// Maten blijven per gekozen kleur doorgestreept. Draait na de eigen code van de productpagina.
(function () {
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) { return null; }
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fixColors() {
    var variants = readJSON('TC-VariantData');
    if (!variants || !variants.length) { return; }
    var stock = readJSON('TC-StockData') || { soldoutBelow: 6, qty: {} };
    function isOut(v) {
      if (!v || !v.available) { return true; }
      var q = stock.qty ? stock.qty[String(v.id)] : null;
      if (q === null || q === undefined) { return false; }
      return q < stock.soldoutBelow;
    }
    document.querySelectorAll('.option-block').forEach(function (block) {
      var labelEl = block.querySelector('.option-label');
      var name = labelEl ? labelEl.textContent.trim().toLowerCase() : '';
      if (name !== 'color' && name !== 'colour' && name !== 'kleur') { return; }
      var pos = parseInt(block.getAttribute('data-option-position'), 10) - 1;
      block.querySelectorAll('.swatch-radio').forEach(function (radio) {
        var allOut = !variants.some(function (v) { return v.options[pos] === radio.value && !isOut(v); });
        var label = block.querySelector('label[for="' + radio.id + '"]');
        if (label) { label.classList.toggle('is-soldout', allOut); }
      });
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('swatch-radio')) {
      setTimeout(fixColors, 0);
    }
  });
  document.addEventListener('DOMContentLoaded', function () { setTimeout(fixColors, 0); });
  window.addEventListener('load', fixColors);
})();

// Foto kiest kleur + altijd een maat die te bestellen is (08-10-2026).
// 1. Klik op een foto van een kleur: die kleur wordt geselecteerd (de aangeklikte foto blijft staan).
//    Kleur van een foto = de kleur waar de foto als variantfoto aan hangt, anders de kleur in de alt-tekst
//    ("Bear Loungewear in Navy, back"). Foto's met meerdere kleuren (zoals de Use-foto) veranderen niets.
// 2. Na het kiezen van een kleur (ook via een foto) en bij het laden van de pagina: is die maat in die kleur
//    uitverkocht, dan springt de keuze naar de dichtstbijzijnde maat die wel te bestellen is (eerst groter, dan kleiner).
//    Had de klant zelf een maat gekozen, dan verschijnt er een korte melding onder de maten.
// Alles loopt via change-events, zodat prijs, voorraadtekst, knop, foto en sticky-balk gewoon meeschakelen.
(function () {
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) { return null; }
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fire(radio) {
    var ev;
    try { ev = new Event('change', { bubbles: true }); }
    catch (e) { ev = document.createEvent('Event'); ev.initEvent('change', true, false); }
    radio.dispatchEvent(ev);
  }

  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function init() {
    var form = document.getElementById('TC-ProductForm');
    var variants = readJSON('TC-VariantData');
    if (!form || !variants || !variants.length) { return; }
    var stock = readJSON('TC-StockData') || { soldoutBelow: 6, qty: {} };

    function isOut(v) {
      if (!v || !v.available) { return true; }
      var q = stock.qty ? stock.qty[String(v.id)] : null;
      if (q === null || q === undefined) { return false; }
      return q < stock.soldoutBelow;
    }

    var blocks = Array.prototype.slice.call(form.querySelectorAll('.option-block'));
    if (!blocks.length) { return; }
    function nameOf(block) {
      var l = block.querySelector('.option-label');
      return l ? l.textContent.trim().toLowerCase() : '';
    }
    function posOf(block) { return parseInt(block.getAttribute('data-option-position'), 10) - 1; }
    function radiosOf(block) { return Array.prototype.slice.call(block.querySelectorAll('.swatch-radio')); }

    var colorBlock = null;
    var sizeBlock = null;
    blocks.forEach(function (b) {
      var n = nameOf(b);
      if (!colorBlock && /colou?r|kleur/.test(n)) { colorBlock = b; }
      else if (!sizeBlock && /size|maat/.test(n)) { sizeBlock = b; }
    });

    function getSelected() {
      var selected = [];
      blocks.forEach(function (b) {
        var checked = b.querySelector('.swatch-radio:checked');
        selected[posOf(b)] = checked ? checked.value : null;
      });
      return selected;
    }
    function findVariant(selected) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== selected[j]) { ok = false; break; }
        }
        if (ok) { return v; }
      }
      return null;
    }

    var assisting = false;
    var userPickedSize = false;

    // Korte melding onder de maten
    var style = document.createElement('style');
    style.textContent = '.tc-size-note{margin:8px 0 0;font-size:13.5px;line-height:1.45;color:#8A6A52}';
    document.head.appendChild(style);
    function clearNote() {
      var n = form.querySelector('.tc-size-note');
      if (n) { n.parentNode.removeChild(n); }
    }
    function showNote(text) {
      clearNote();
      if (!sizeBlock) { return; }
      var p = document.createElement('p');
      p.className = 'tc-size-note';
      p.setAttribute('role', 'status');
      p.textContent = text;
      sizeBlock.appendChild(p);
    }

    // Kies de dichtstbijzijnde maat die te bestellen is, als de huidige combinatie uitverkocht is.
    function ensureAvailableSize(withNote) {
      if (!sizeBlock) { return; }
      var selected = getSelected();
      var current = findVariant(selected);
      if (current && !isOut(current)) { return; }
      var sp = posOf(sizeBlock);
      var sizes = radiosOf(sizeBlock);
      var idx = -1;
      sizes.forEach(function (r, i) { if (r.checked) { idx = i; } });
      var order = [];
      if (idx < 0) {
        for (var a = 0; a < sizes.length; a++) { order.push(a); }
      } else {
        for (var d = 1; d < sizes.length; d++) {
          if (idx + d < sizes.length) { order.push(idx + d); }
          if (idx - d >= 0) { order.push(idx - d); }
        }
      }
      for (var k = 0; k < order.length; k++) {
        var test = selected.slice();
        test[sp] = sizes[order[k]].value;
        var v = findVariant(test);
        if (v && !isOut(v)) {
          var oldSize = idx >= 0 ? sizes[idx].value : null;
          var target = sizes[order[k]];
          assisting = true;
          target.checked = true;
          fire(target);
          assisting = false;
          if (withNote && userPickedSize && oldSize) {
            var colorText = '';
            if (colorBlock) {
              var c = colorBlock.querySelector('.swatch-radio:checked');
              if (c) { colorText = ' in ' + c.value; }
            }
            showNote('Size ' + oldSize + ' is sold out' + colorText + ', so we selected ' + target.value + ' for you.');
          }
          return;
        }
      }
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (assisting || !t || !t.classList || !t.classList.contains('swatch-radio')) { return; }
      var block = t.closest ? t.closest('.option-block') : null;
      if (!block || blocks.indexOf(block) === -1) { return; }
      if (e.isTrusted) { clearNote(); }
      if (block === sizeBlock) {
        if (e.isTrusted) { userPickedSize = true; }
        return;
      }
      ensureAvailableSize(true);
    });

    // Foto → kleur
    if (colorBlock) {
      var cp = posOf(colorBlock);
      var colorRadios = radiosOf(colorBlock);
      var mediaColors = {};
      variants.forEach(function (v) {
        if (!v.featured_media || !v.featured_media.id) { return; }
        var key = String(v.featured_media.id);
        mediaColors[key] = mediaColors[key] || [];
        if (mediaColors[key].indexOf(v.options[cp]) === -1) { mediaColors[key].push(v.options[cp]); }
      });
      var titleEl = document.querySelector('.product-info h1');
      var title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';

      var colorForThumb = function (thumb) {
        var linked = mediaColors[String(thumb.getAttribute('data-tc-media-id'))];
        if (linked && linked.length === 1) { return linked[0]; }
        var alt = (thumb.getAttribute('alt') || '').toLowerCase();
        if (title) { alt = alt.split(title).join(' '); }
        var found = colorRadios.map(function (r) { return r.value; }).filter(function (c) {
          return new RegExp('(^|[^a-z0-9])' + escapeRe(c.toLowerCase()) + '([^a-z0-9]|$)').test(alt);
        });
        // "Grey" telt niet als ook "Light Grey" gevonden is
        found = found.filter(function (c) {
          return !found.some(function (o) { return o !== c && o.toLowerCase().indexOf(c.toLowerCase()) !== -1; });
        });
        return found.length === 1 ? found[0] : null;
      };

      var thumbSync = false;
      document.addEventListener('click', function (e) {
        if (thumbSync || !e.target || !e.target.closest) { return; }
        var thumb = e.target.closest('[data-tc-thumb]');
        if (!thumb) { return; }
        var color = colorForThumb(thumb);
        if (!color) { return; }
        var radio = null;
        colorRadios.forEach(function (r) { if (r.value === color) { radio = r; } });
        if (!radio || radio.checked) { return; }
        radio.checked = true;
        fire(radio);
        // De kleurwissel toont de hoofdfoto van die kleur; zet de aangeklikte foto terug.
        thumbSync = true;
        thumb.click();
        thumbSync = false;
      });
    }

    // Bij het laden (bijv. via een link naar een uitverkochte maat): direct een leverbare maat kiezen.
    ensureAvailableSize(false);
  }

  function start() { setTimeout(init, 0); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
